import React from "react";

const CompanyListItemSkeleton = () => (
  <div className="px-lg mb-lg rounded-lg border border-solid border-primary bg-primary flex items-center justify-between min-h-[4rem] py-md animate-pulse">
    <div className="flex items-center gap-md flex-1 min-w-0">
      <div className="w-3xl h-3xl flex-shrink-0 bg-gray-10 rounded-full" />
      <div className="flex flex-col min-w-0 flex-1 gap-xs">
        <div className="h-3.5 bg-gray-10 rounded w-48" />
        <div className="flex items-center gap-xs">
          <div className="h-2.5 bg-gray-10 rounded w-10 shrink-0" />
          <div className="h-2.5 bg-gray-10 rounded w-1 shrink-0" />
          <div className="h-2.5 bg-gray-10 rounded w-64" />
        </div>
      </div>
    </div>
    <div className="flex items-center gap-md flex-shrink-0">
      <div className="h-2xl w-20 bg-gray-10 rounded" />
      <div className="h-lg w-lg bg-gray-10 rounded" />
    </div>
  </div>
);

export const CompanyLoaderComponent = ({ total = 2 }: { total?: number }) => (
  <>
    {Array.from({ length: total }).map((_, i) => (
      <CompanyListItemSkeleton key={i} />
    ))}
  </>
);
